'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('./ui-picture.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Picture = function (_Component) {
    _inherits(Picture, _Component);

    function Picture(props) {
        _classCallCheck(this, Picture);

        var _this = _possibleConstructorReturn(this, (Picture.__proto__ || Object.getPrototypeOf(Picture)).call(this, props));

        _this.onLoad = _this.onLoad.bind(_this);
        _this.ref_image = _react2.default.createRef();

        _this.state = {
            isLoading: true
        };
        return _this;
    }

    _createClass(Picture, [{
        key: 'onLoad',
        value: function onLoad() {
            var img = this.ref_image.current;

            if (img && img.complete) {
                this.setState({ isLoading: false });
            }
        }
    }, {
        key: 'isValidPicture',
        value: function isValidPicture() {
            return this.props.sources instanceof Array && this.props.src && this.props.id;
        }
    }, {
        key: 'renderPicture',
        value: function renderPicture() {
            var _this2 = this;

            return _react2.default.createElement(
                'picture',
                { className: [this.props.classNamePicture ? this.props.classNamePicture : "uiPicture"].join(" ") },
                this.props.sources.map(function (source, i) {
                    return _react2.default.createElement('source', { key: _this2.props.id + '_source_' + i,
                        srcSet: source.srcset,
                        type: source.type,
                        media: source.media,
                        sizes: source.sizes });
                }),
                _react2.default.createElement('img', { src: this.props.src,
                    ref: this.ref_image,
                    style: this.props.style,
                    className: [this.props.className ? this.props.className : "uiPictureImage", this.state.isLoading ? "loading" : "loaded"].join(" "),
                    onLoad: this.onLoad,
                    loading: this.props.loading,
                    decoding: this.props.decoding,
                    alt: this.props.alt,
                    width: this.props.width,
                    height: this.props.height,
                    onClick: this.props.onClick })
            );
        }
    }, {
        key: 'renderLowQualityPicture',
        value: function renderLowQualityPicture() {
            var _this3 = this;

            return _react2.default.createElement(
                'picture',
                { className: [this.props.classNamePictureLowQuality ? this.props.classNamePictureLowQuality : "uiPictureLowQuality"].join(" ") },
                this.props.sources.map(function (source, i) {
                    return _react2.default.createElement('source', { key: _this3.props.id + '_source_' + i,
                        srcSet: _this3.getLowQualityImageUrl(source.srcset),
                        type: source.type,
                        media: source.media,
                        sizes: source.sizes });
                }),
                _react2.default.createElement('img', { src: this.getLowQualityImageUrl(this.props.src),
                    ref: this.ref_image,
                    style: this.props.style,
                    importance: 'high',
                    className: [this.props.classNameImageLowQuality ? this.props.classNameImageLowQuality : "uiPictureImageLowQuality", this.state.isLoading ? "loading" : "loaded"].join(" "),
                    loading: this.props.loading,
                    decoding: this.props.decoding,
                    alt: "",
                    width: this.props.width,
                    height: this.props.height })
            );
        }
    }, {
        key: 'getLowQualityImageUrl',
        value: function getLowQualityImageUrl(url) {
            if (!url) {
                return "";
            }

            var width = 100;
            var quality = 10;

            return url.replace(/(q=)[^&]+/g, '$1' + quality).replace(/(w=)[^&]+/g, '$1' + width);
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.isValidPicture()) {
                return "";
            }

            return this.props.useLowQualityImage ? _react2.default.createElement(
                'div',
                { className: this.props.classNamePictureWrapper ? this.props.classNamePictureWrapper : "uiPictureWrapper" },
                this.renderLowQualityPicture(),
                this.renderPicture()
            ) : this.renderPicture();
        }
    }]);

    return Picture;
}(_react.Component);

exports.default = Picture;